import { yup } from "@swa-ui/object";

import {
  APARTMENT_SUITE_SCHEMA_FIELD_NAME,
  getApartmentSuiteFormFieldSchema,
} from "../ApartmentSuiteFormField";
import { CITY_SCHEMA_FIELD_NAME, getCityFormFieldSchema } from "../CityFormField";
import { COUNTRY_SCHEMA_FIELD_NAME, getCountryFormFieldSchema } from "../CountryFormField";
import { getStateFormFieldSchema, STATE_SCHEMA_FIELD_NAME } from "../StateFormField";
import { getStateProvinceRegionFormFieldSchema } from "../StateProvinceRegionFormField";
import {
  getStreetAddressFormFieldSchema,
  STREET_ADDRESS_SCHEMA_FIELD_NAME,
} from "../StreetAddressFormField";
import {
  getZipCodeFormFieldSchema,
  UNITED_STATES_COUNTRY_CODE,
  ZIPCODE_SCHEMA_FIELD_NAME,
} from "../ZipCodeFormField";

export const getAddressFormFieldsSchema = (options = {}) => {
  const {
    aptSuiteLabel,
    aptSuiteSchemaName = APARTMENT_SUITE_SCHEMA_FIELD_NAME,
    citySchemaName = CITY_SCHEMA_FIELD_NAME,
    countrySchemaName = COUNTRY_SCHEMA_FIELD_NAME,
    stateSchemaName = STATE_SCHEMA_FIELD_NAME,
    streetAddressLabel,
    streetAddressSchemaName = STREET_ADDRESS_SCHEMA_FIELD_NAME,
    zipCodeLabel,
    zipCodeSchemaName = ZIPCODE_SCHEMA_FIELD_NAME,
  } = options;

  return {
    [countrySchemaName]: getCountryFormFieldSchema(),
    [streetAddressSchemaName]: getStreetAddressFormFieldSchema(streetAddressLabel),
    [aptSuiteSchemaName]: getApartmentSuiteFormFieldSchema(aptSuiteLabel),
    [citySchemaName]: getCityFormFieldSchema(),
    [stateSchemaName]: yup.string().when(countrySchemaName, {
      is: (value) => value === UNITED_STATES_COUNTRY_CODE,
      otherwise: getStateProvinceRegionFormFieldSchema(),
      then: getStateFormFieldSchema(),
    }),
    [zipCodeSchemaName]: getZipCodeFormFieldSchema(countrySchemaName, zipCodeLabel),
  };
};
